export interface PageContext {
  pathname: string;
  organizationId?: string;
}

import { useLocation } from 'react-router-dom';
import { useOrganization } from '@/contexts/OrganizationContext';

export function usePageContext(): PageContext {
  const location = useLocation();
  const { currentOrganization } = useOrganization();

  return {
    pathname: location.pathname,
    organizationId: currentOrganization?.id,
  };
}
